"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdpAxiosClientFactory = void 0;
const inversify_1 = require("inversify");
const core_1 = require("@vacasa/core");
const idp_axios_client_1 = require("./idp-axios-client");
let IdpAxiosClientFactory = class IdpAxiosClientFactory {
    constructor(loggingService) {
        this.loggingService = loggingService;
    }
    getFor(idpConfiguration, serviceConfiguration) {
        return new idp_axios_client_1.IdpAxiosClient(idpConfiguration, serviceConfiguration, this.loggingService);
    }
};
IdpAxiosClientFactory = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(core_1.LoggingServiceNS.LOGGING_SERVICE_ID)), __param(0, inversify_1.optional()),
    __metadata("design:paramtypes", [Object])
], IdpAxiosClientFactory);
exports.IdpAxiosClientFactory = IdpAxiosClientFactory;
//# sourceMappingURL=idp-axios-client-factory.js.map